import { MetadataType } from '../metadata/MetadataType';
import { IProcedure } from '../Procedure';
import { IMetadata } from '../metadata/Metadata';

export interface IOutput {
  id: string;
  key: string;
  label: string;
  target: OutputTargetType;
  datatype: MetadataType;
  choices?: string[];
  common: boolean;
  required: boolean;
  procedure: IProcedure;
  procedureId: number;
  metadata?: IMetadata;
  metadataId?: string | null;
}

export type IOutputCreate = Omit<IOutput, 'procedure' | 'procedureId'>;

export enum OutputTargetType {
  Dossier = 'Dossier',
  Document = 'Document'
}

export function outputToLabel(output: IOutput) {
  return `${
    output.target === OutputTargetType.Dossier ? 'Fascicolo' : 'Documento'
  } - ${output.label}${output.required ? ' (*)' : ''}`;
}

export enum StandardOutputKey {
  Title = 'std_titolo',
  AuthorMail = 'std_mittente_email',
  AuthorName = 'std_mittente_nome',
  AuthorSurname = 'std_mittente_cognome',
  AuthorAddress = 'std_mittente_indirizzo',
  FiscalCode = 'std_codice_fiscale',
  OwnerFullName = 'std_responsabile'
}
